import { Action } from '@ngrx/store';

import { UserBill } from 'modules/shared/models/billable.models';
import { LoadBillablePayload, CheckBalancePayload } from 'store/models/billable.models';

export enum BillableActionTypes {
  LOAD_BILLABLE = 'LOAD_BILLABLE',
  LOAD_BILLABLE_SUCCESS = 'LOAD_BILLABLE_SUCCESS',
  LOAD_BILLABLE_FAILURE = 'LOAD_BILLABLE_FAILURE',
  CHECK_BALANCE = 'CHECK_BALANCE',
  CHECK_BALANCE_SUCCESS = 'CHECK_BALANCE_SUCCESS',
  CHECK_BALANCE_FAILURE = 'CHECK_BALANCE_FAILURE'
}

export type BillableActions =
  LoadBillable |
  LoadBillableSuccess |
  LoadBillableFailure;

export class LoadBillable implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.LOAD_BILLABLE;
  constructor(public payload: LoadBillablePayload = null) { }
}

export class LoadBillableSuccess implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.LOAD_BILLABLE_SUCCESS;
  constructor(public payload: UserBill = null) { }
}

export class LoadBillableFailure implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.LOAD_BILLABLE_FAILURE;
  constructor(public payload: any = null) { }
}

export class CheckBalance implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.CHECK_BALANCE;
  constructor(public payload: CheckBalancePayload = null) { }
}

export class CheckBalanceSuccess implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.CHECK_BALANCE_SUCCESS;
  constructor(public payload: any = null) { }
}

export class CheckBalanceFailure implements Action {
  readonly type: BillableActionTypes = BillableActionTypes.CHECK_BALANCE_FAILURE;
  constructor(public payload: any = null) { }
}
